//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { SupplierDTO } from 'src/app/core/models/system/supplier/supplier.dto';

@Injectable({ providedIn: 'root' })

export class SuppliersService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getIdAndAlias(userId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<SupplierDTO[]>(environment.eSimApi +
                                                                             eSimApiPaths.Suppliers +
                                                                             "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndAliasConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndAliasConverter(supplier: SupplierDTO) {
    return {id: supplier.id, description: supplier.alias};
  }

  public idAndAliasLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndAlias(userId));
          }
        }),
        sort: "alias"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  //#region idAndDescription

  // public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
  //   try {
  //     return this.httpClientService.get<SupplierDTO[]>(environment.eSimApi + eSimApiPaths.Suppliers)
  //     .pipe(
  //       map(x => x.map(this.idAndDescriptionConverter))
  //     );
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //     return of();
  //   }
  // }

  // private idAndDescriptionConverter(supplier: SupplierDTO) {
  //   return {id: supplier.id, description: supplier.name};
  // }

  // public idAndDescriptionLookupDataSource(): {} {
  //   try {
  //     return {
  //       store: new CustomStore({
  //         key: "id",
  //         loadMode: "raw",
  //         load: () => {
  //           return lastValueFrom(this.getIdAndDescription());
  //         }
  //       }),
  //       sort: "description"
  //   };
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //     return {};
  //   }
  // }

  //#endregion
}
